<template>
  <div
    v-if="show"
    :class="['tip-match-award-des',
             !isAbsolute ? '':'tip-match-position',
             animateShow ? 'tip-match-top-enter':'tip-match-top-leave']"
    :style="{ background: backgroundColor, boxShadow: boxShadow }"
  >
    <div class="tip-match-award-des-text">
      <div
        v-if="iconUrl"
        class="tip-match-award-des-icon"
      >
        <img :src="getCompressImgUrl(iconUrl, 19, 15)">
      </div>
      <div>
        {{ text }}
        <p
          class="tip-match-btn"
          v-if="linkText"
          id="copy"
          :data-clipboard-text="link"
          @click="onLinkClick"
        >
          {{ linkText }}
        </p>
      </div>
    </div>
    <div
      v-if="isSort && isShowIcon"
      class="iconfont icon-sort"
      @click="clickSort"
    />
    <div
      v-else-if="isShowIcon"
      class="iconfont icon-close"
      @click="closeNotice"
    />
  </div>
</template>
<script>
import { copyText } from '@tencent/pmd-widget/lib/copy';


export default {
  props: {
    isSort: {
      type: Boolean,
      default: false,
    },
    isShowNotice: {
      type: Boolean,
      default: false,
      desc: '外部控制是否显示',
      required: false,
    },
    // notice文案
    text: {
      type: String,
      default: 'notice文案notice文案notice文案notice文案notice文案notice文案notice文案notice文案notice文案notice文案notice文案notice文案notice文案',
    },
    // 尾部链接文案
    linkText: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    // 是否position: absolute; 设置为flase可以插入在页面中
    isAbsolute: {
      type: Boolean,
      default: true,
    },
    backgroundColor: {
      type: String,
      default: '',
    },
    boxShadow: {
      type: String,
      default: '',
    },
    iconUrl: {
      type: String,
      default: '',
    },
    isShowIcon: {
      type: Boolean,
      desc: '是否显示icon, 默认显示',
      default: true,
    },
  },
  options: {
    virtualHost: true,
  },
  data() {
    return {
      show: false,
      animateShow: false,
      // top: '',
    };
  },
  computed: {},
  watch: {
    isShowNotice: {
      handler(newVal) {
        if (newVal) {
          this.show = newVal;
          this.animateShow = newVal;
        } else {
          // remove
          this.animateShow = newVal;
          setTimeout(() => {
            this.show = newVal;
          }, 300);
        }
        // this.setTop();
      },
      immediate: true,
    },
  },
  mounted() {
  },
  methods: {
    onLinkClick() {
      if (this.link.length > 0) {
        copyText(this.link);
      }
      this.$emit('onLinkClick');
    },
    closeNotice() {
      this.$emit('closeNotice');
    },
    clickSort() {
      this.$emit('onSortClick');
    },
    // mp需要计算
    // setTop() {
    //   const menuInfo = uni.getStorageSync('menuInfo');
    //   const headerHeight = menuInfo?.headerHeight;
    //   if (menuInfo?.headerHeight > 0) {
    //     this.top = `${headerHeight}px`;
    //   }
    // },
  },
};

</script>
<style lang="scss" scoped src="./css/index.scss"></style>
